// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__Kc02S","footer":"Form_footer__H9hZV"};